import { atom } from 'jotai';
import { IGetRefinerResponse } from '../models/IGetRefinerResponse';

import { ILocation } from '../models/ILocation';
import { IRefinerItems } from '../models/IRefinerItems';
import { ISelectedRefinerItem } from '../models/ISelectedRefinerItem';
import { ISite } from '../models/ISite';
import Constants from './Constants';

export const locationsAtom = atom<Array<ILocation>>([]);
export const sitesAtom = atom<Array<ISite>>([]);
export const refinersAtom = atom<Array<IGetRefinerResponse>>([]);
export const userNameAtom = atom<string | null>(null);
export const selectedLocationIdAtom = atom<number>(Constants.DEFAULT_ID);
export const selectedSiteAtom = atom<ISite | null>(null);
export const refinersExpandedAtom = atom<boolean>(true);
export const refinerItemsAtom = atom<IRefinerItems>({});
export const selectedRefinerItemsAtom = atom<Array<ISelectedRefinerItem>>([]);
export const searchKeywordAtom = atom('');
export const pageSizeAtom = atom(10);
export const isInitializingAtom = atom(false);
export const selectedStateAtom = atom<string | null>(null);
export const navbarHeightAtom = atom(0);
export const startRowSpecificSearchAtom = atom(0);
export const currentPageIndexSpecificSearchAtom = atom(1);
export const startRowGeneralSearchAtom = atom(0);
export const currentPageIndexGeneralSearchAtom = atom(1);

export const isAuthenticatedAtom = atom((get) => !!get(userNameAtom));
